import styled from 'styled-components';
import { typography } from 'styles/settings';

export const Text = styled.span`
  ${typography.font.medium};
  font-size: ${typography.size.md};
  line-height: ${typography.size.lg};
`;
